import {reactive} from "vue";

class beastMode{
    constructor() {
        this._beastDatas = reactive([]);
        this._rankDatas = [];
    }

    processBeastDataType = (datas) => {
        // console.log(datas);
        datas.forEach(data=>{
            const mythicalBeast = {
                id: data.id,
                enName: data.type,
                name: data.name,
                // smallName: data.name[1],
                summary: data.summary,
                positionName: data.position[0],
                positionLink: data.position[1],
                icon: data.icon[0],
                image: data.image[0],
                basicData: data.basic_data,
                skillData: data.skill_data,
                material: data.material,
                link: data.link,
                rankID: data.rank_id
            };
            // console.log(data.basic_data);
            // console.log(data.skill_data);
            this._beastDatas.push(mythicalBeast);
        });
    }

    set rankDatas(datas){

        this._rankDatas = datas.sort((a,b)=>{
            // console.log(a);
            // console.log(b);
            return b.ticket - a.ticket;
        });

        this._rankDatas.forEach((element,index)=>{
            element.rank = index+1;
        })
        // console.log(this._rankDatas);
    }

    get beastDatas(){
        return this._beastDatas;
    }

    get rankDatas(){
        return this._rankDatas;
    }

    getAllTicket = () => {
        let total = 0;
        this._rankDatas.forEach((rank)=>{
            // console.log(rank);
            total = total + rank.ticket;
        });
        // console.log(total);
        return total;
    }

    findBeastData = (id) => {
        return this._beastDatas.find(beast => {
            if(beast.id === parseInt(id)) {
                return beast;
            }
        })
    }

    findRankData = (id) => {
        return this._rankDatas.find(rank => {
            if(rank.rank_id === parseInt(id)) {
                return rank;
            }
        })
    }

    loadingBeastLogo = (enName) => {
        try{
            return require(`../assets/images/logo/${enName}.png`);
        } catch (e) {
            return require("../assets/images/beasts/vote-logo.webp");
        }
    }

    loadingBeastImage = (enName) => {
        try{
            return require(`../assets/images/beasts/${enName}.webp`);
        } catch (e) {
            return require("../assets/images/beasts/Phoenix.webp");
        }
    }

    loadingBeastApng = (enName) => {
        try{
            return require(`../assets/apng/${enName}.png`);
        } catch (e) {
            return require("../assets/images/svg/question.svg");
        }
    }

    // beastImageLoop = (enName) => {
    //     const images = [];
    //     let beastImageDataLength;
    //     if (enName === 'dragon') {
    //         // filename = 'Kamaja-zip';
    //         beastImageDataLength = 408;
    //     }
    //     else if(enName === 'Phoenix'){
    //         beastImageDataLength = 380;
    //     }
    //     else if(enName === 'Suanni' || enName === 'Jiaotu'){
    //         beastImageDataLength = 361;
    //     }
    //     else if(enName === 'Sword Lion'){
    //         beastImageDataLength = 609;
    //     }
    //     else if(enName === 'Spring cattle' || enName === 'Hedgehog'){
    //         beastImageDataLength = 451;
    //     }
    //     else if(enName === 'Kirin'){
    //         beastImageDataLength = 451;
    //     }
    //     else if(enName === 'Bixi'){
    //         beastImageDataLength = 356;
    //     }
    //     else if(enName === 'bat'){
    //         beastImageDataLength = 1;
    //     }
    //     else{
    //         //bat, Elephant, Fire Horse, Huye, Kamaja, Shishi
    //         beastImageDataLength = 360;
    //     }
    //
    //     for (let x = 1; x <= beastImageDataLength; x++) {
    //         // const paddedNumber = String(x).padStart(4, '0');
    //         let imagePath;
    //         if(enName=== 'bat'){
    //             // continue;
    //             imagePath = require(`../assets/apng/${enName}.png`);
    //         }else{
    //             imagePath = require(`../assets/video/${enName}/${enName}-${x}.png`);
    //         }
    //         // const imagePath = require(`../assets/video/${enName}/${enName}-${x}.png`);
    //         // const imagePath = `http://192.168.0.74/test/images/${enName}/${enName}-${x}.png`;
    //
    //         images.push(imagePath);
    //     }
    //     return images;
    // }


    beastsDataSlot = (mode) => {

        const ticketMap = new Map();
        this._rankDatas.forEach(rankData=>{
            ticketMap.set(rankData.rank_id,rankData.rank);
        });

        this._beastDatas.sort((a,b)=>{
            const ticketA = ticketMap.get(a.id);
            const ticketB = ticketMap.get(b.id);

            if(ticketA === undefined || ticketB === undefined) {
                return 0;
            }

            if(mode === "default"){
                return (a.id)-(b.id);
            }
            else if(mode === "high"){
                return ticketA - ticketB;
            }
            else{
                return ticketB - ticketA;
            }
        });
    }

}
const mythicalBeast = new beastMode();

export default mythicalBeast;